import { Icon, IconProps } from "../Icon";

const InformationFilled = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.002 4H5.998C4.89454 4 4 4.89454 4 5.998V26.002C4 27.1055 4.89454 28 5.998 28H26.002C26.5319 28 27.0401 27.7895 27.4148 27.4148C27.7895 27.0401 28 26.5319 28 26.002V5.998C28 5.4681 27.7895 4.9599 27.4148 4.5852C27.0401 4.2105 26.5319 4 26.002 4ZM16 7C16.8284 7 17.5 7.67157 17.5 8.5C17.5 9.32843 16.8284 10 16 10C15.1716 10 14.5 9.32843 14.5 8.5C14.5 7.67157 15.1716 7 16 7ZM20 24.12H12V21.88H14.88V15.12H13V12.88H17.13V21.88H20V24.12Z"
      fill="currentColor"
    />
  </Icon>
);

export default InformationFilled;
